<div class="{{ className }}">
  <label [attr.for]="effectiveInputId" [attr.id]="effectiveInputId + '-a11y-label'">{{ 'FLEX_PERIOD' | translate }}</label>
  @if (form && controlName) {
    <app-auto-complete
      (selectedItemChange)="onSelectChangeFlex($event)"
      (searchChange)="onSearchChangeFlex($event)"
      [itemsData]="flexs"
      [selectedItem]="form.get(controlName)?.value"
      [searchOnClick]="true"
      [minTermLength]="0"
      [inputId]="effectiveInputId"
      [labelElementId]="effectiveInputId + '-a11y-label'"
      [ariaLabel]="'FLEX_PERIOD' | translate"
      [describedBy]="describedBy"
      [ariaInvalid]="invalid"
    ></app-auto-complete>
  }
</div>
